import camelcaseKeys from 'camelcase-keys';
const transformSummaryResponse = (response) => {
    var _a;
    const data = camelcaseKeys(response, { deep: true });
    const summaryItems = (_a = data === null || data === void 0 ? void 0 : data.summaries[0]) === null || _a === void 0 ? void 0 : _a.summaries;
    const transformedData = summaryItems === null || summaryItems === void 0 ? void 0 : summaryItems.map((summary) => ({
        ...summary,
        key: summary.key.replace(/^(Lease|Cash|Finance)/, ''),
    }));
    return { transformedData, originalResponse: response };
};
export default transformSummaryResponse;
